import { VaultAuditItemApi, VaultDisclosuresResponseApi } from "../api/vault-disclosures";
import { VaultAuditItem, VaultDisclosuresResponse } from "../domain/vault-disclosures";

export function parseVaultDisclosuresFromApi(api: VaultDisclosuresResponseApi): VaultDisclosuresResponse {
    return {
        disclaimer: api.disclaimer,
        risks: api.risks,
        audits: api.audits.map(parseVaultAuditItemFromApi),
        documentation: api.documentation
    };
}

export function parseVaultAuditItemFromApi(api: VaultAuditItemApi): VaultAuditItem {
    return {
        ...api,
        auditedAt: parseIsoDateLocal(api.auditedAt)
    };
}

// `new Date("YYYY-MM-DD")` parses as UTC midnight, which shifts the displayed day
// for users west of UTC. Construct from local components so the audit date renders
// as the calendar day the curator intended.
function parseIsoDateLocal(isoDate: string): Date {
    const [year, month, day] = isoDate.split("-").map(Number);
    return new Date(year, month - 1, day);
}
